import './CompanyProfileImageBanner.scss';

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import EditableImage from 'components/EditableImage';

import cxHelpers from 'util/className';

const defaultCoverSrc = require('./icons/empty-company-bg-image@2x.png');
const defaultLogoSrc = require('./icons/empty-company-logo.png');

@cxHelpers('CompanyProfileImageBanner')
export default class CompanyProfileImageBanner extends PureComponent {
  static propTypes = {
    isEditing: PropTypes.bool.isRequired,
    updateFormField: PropTypes.func.isRequired,
    coverSrc: PropTypes.string,
    logoSrc: PropTypes.string,
  };

  handleUpdatePhoto = (fieldName, fieldData) => {
    this.props.updateFormField(fieldName, fieldData);
  };

  render() {
    const { isEditing, coverSrc, logoSrc } = this.props;

    return (
      <div className={this.cx()}>
        <div className={this.cxEl('cover-wrapper')}>
          <EditableImage
            isEditing={isEditing}
            // If editing, it wont load the default cover image because of CORS issue
            src={isEditing ? coverSrc : coverSrc || defaultCoverSrc}
            fieldName="cover"
            ratio="5:1"
            parentCxElClass={this.cxEl('cover')}
            onUpdatePhoto={this.handleUpdatePhoto}
            productLocation="Company Profile - Cover"
          />
        </div>
        <div className={this.cxEl('logo-wrapper')}>
          <EditableImage
            isEditing={isEditing}
            src={logoSrc || defaultLogoSrc}
            fieldName="logo"
            ratio="1:1"
            parentCxElClass={this.cxEl('logo')}
            onUpdatePhoto={this.handleUpdatePhoto}
            productLocation="Company Profile - Logo"
          />
        </div>
      </div>
    );
  }
}
